import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

// pages here
import Index from "./pages/index";
import { ResetConfirm, ResetRequest } from "./pages/auth/reset";
import { RegisterForm, RegisterVerify } from "./pages/auth/register";
import NoteBook from "./pages/notebook";
import Timeline from "./pages/tests/timeline";
import HomePageV3 from "./pages/v3/HomePage";

const FormulaSheets = lazy(() => import("./pages/formula-sheets"));
const RevisionNotes = lazy(() => import("./pages/revision-notes"));
const DownloadMiscPdf = lazy(() => import("./pages/download-misc-pdf"));

const Onboarding = lazy(() => import("./pages/onboarding"));
const ErrorPage = lazy(() => import("./pages/error"));
const DashboardPage = lazy(() => import("./pages/dashboard/index"));
const Test = lazy(() => import("./pages/packs/v2-Test-Analysis/test"));
const TestDemo = lazy(() => import("./pages/packs/v2-Test-Analysis-Demo/test"));
const JeeMainAnalysis = lazy(() => import("./pages/packs/jee-main-analysis/test"));

const TestOld = lazy(() => import("./pages/packs/test/test"));
const LeaderBoard = lazy(() => import("./pages/packs/test/leaderboard"));
const Version = lazy(() => import("./pages/version"));

const Profile = lazy(() => import("./pages/account/profile"));
const Settings = lazy(() => import("./pages/account/settings"));
const PreparationDetails = lazy(() => import("./pages/account/preparation-details"));
const Solutions = lazy(() => import("./pages/packs/test/solutions"));
const TestSeries = lazy(() => import("./pages/test-series"));

// Pack Analysis
const PackAnalysisHome = lazy(() => import("./pages/packs/analysis/PackAnalysisHome"));

// Session Recordings
const SessionRecordings = lazy(() => import("./pages/v2/session-recordings"));

// RESO
const Reso = lazy(() => import("./pages/reso"));
const ResoChapter = lazy(() => import("./pages/reso/Subject/Chapter"));

// Auth Routes
const Auth = lazy(() => import("./pages/auth"));
const AuthAdmin = lazy(() => import("./pages/auth/admin"));
const Logout = lazy(() => import("./pages/auth/logout"));

// Test Routes
const TestUI = lazy(() => import("./pages/tests"));
const Inst = lazy(() => import("./pages/tests/instructions"));
const Sub = lazy(() => import("./pages/tests/submission"));
const Login = lazy(() => import("./pages/auth/login"));
import Maintenance from "./pages/maintenance";
const GraphTest = lazy(() => import("./pages/graphs"));

// V2 Design Routes
const Home = lazy(() => import("./pages/v3/HomePage"));
const Dash = lazy(() => import("./pages/v2/dash"));
const OverallAnalysis = lazy(() => import("./pages/v2/overallPackAnalysis"));
const SubjectAnalysis = lazy(() => import("./pages/v2/subjectWiseAnalysis"));
const ChapterAnalysis = lazy(() => import("./pages/v2/chapterWiseAnalysis"));

const PackHomeV3 = lazy(() => import("./pages/packs/PackHomeV3"));
const PackProgress = lazy(() => import("./pages/packs/progress/PackProgress"));

const Coupons = lazy(() => import("./pages/coupons"));

const UP = JSON.parse(localStorage.getItem("userProfile"));
const bg = UP ? (UP.settings.isDarkTheme ? "#12263F" : "white") : "white";

const Router = () => {
  return import.meta.env.VITE_MAINTENANCE_MODE ? (
    <Maintenance />
  ) : (
    <Suspense fallback={<div style={{ height: "100vh", backgroundColor: bg }}></div>}>
      <Routes>
        {/* 
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/auth/admin" element={<AuthAdmin />} />
          <Route path="/auth/register" element={<RegisterForm />} />
          <Route path="/auth/verifyEmail" element={<RegisterVerify />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/reset/request" element={<ResetRequest />} />
          <Route path="/auth/reset/confirm" element={<ResetConfirm />} />
          <Route path="/account" element={<Profile />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/test-series" element={<TestSeries />} />
          <Route path="/account/profile" element={<Profile />} />
          <Route path="/account/settings" element={<Settings />} />
          <Route path="/account/preparation-details" element={<PreparationDetails />} />
          <Route path="/packs/:packId/progress" element={<PackProgress />} />
          <Route path="/packs/:packId" element={<PackHomeV3 />} />
          <Route path="/v2/home" element={<Home />} />
          <Route path="/v2/dash" element={<Dash />} />
          <Route path="/v2/overall-pack-analysis" element={<OverallAnalysis />} />
          <Route path="/v2/subject-wise-analysis" element={<SubjectAnalysis />} />
          <Route path="/v2/chapter-wise-analysis" element={<ChapterAnalysis />} />
          <Route path="/v3/home" element={<HomePageV3 />} />
          <Route path="/v2/:packId/analysis/*" element={<PackAnalysisHome />} />
          <Route path="/v2/:packId/revision-notes" element={<RevisionNotes />} />
          <Route path="/v2/:packId/formula-sheets" element={<FormulaSheets />} />
          <Route path="/v2/:packId/session-recordings" element={<SessionRecordings />} />
          <Route path="/v2/:packId/download-misc-pdf" element={<DownloadMiscPdf />} />
          <Route path="/v2/notebooks" element={<NoteBook />} />
          <Route path="/v2/reso/:subjectId/:chapterId" element={<ResoChapter />} />
          <Route path="/v2/reso" element={<Reso />} />
          <Route path="/tests/timeline" element={<Timeline />} />
        */}
        <Route path="/tests/:pack/:test/submission" element={<Sub />} />
        <Route path="/tests/:pack/:test/instructions" element={<Inst />} />
        <Route path="/tests/:pack/:test" element={<TestUI />} />
        {/*
          <Route path="/:packId/:testId/solutions" element={<Solutions />} />
          <Route path="/:packId/:testId/leaderboard" element={<LeaderBoard />} />
          <Route path="/:packId/:testId/old-ui" element={<TestOld />} />
          <Route path="/:packId/:testId" element={<Test />} />
          <Route path="/jee-main-analysis" element={<JeeMainAnalysis />} />
          <Route path="/version" element={<Version />} />
          <Route path="/graphs" element={<GraphTest />} />
          <Route path="/coupons" element={<Coupons />} />
          */}
        <Route path="/analysis-demo" element={<TestDemo />} />
        <Route path="/no-connection" element={<ErrorPage type={504} />} />
        <Route path="*" element={<ErrorPage type={404} />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
